import { FaMugHot, FaCouch, FaCookieBite, FaBeerMugEmpty } from 'react-icons/fa6';

const features = [
  {
    id: 1,
    icon: <FaMugHot />, // Premium Coffee Beans icon
    title: 'Premium Coffee Beans',
    description: 'We source the best beans from around the world for rich taste in every cup.',
  },
  {
    id: 2,
    icon: <FaCouch />, // Cozy Ambiance icon
    title: 'Cozy Ambiance',
    description: 'Relax in a warm, inviting atmosphere that’s perfect for unwinding or catching up with friends.',
  },
  {
    id: 3,
    icon: <FaCookieBite />, // Artisan Pastries icon
    title: 'Artisan Pastries',
    description: 'Indulge in a selection of freshly baked pastries and treats crafted by our talented bakers.',
  },
  {
    id: 4,
    icon: <FaBeerMugEmpty />, // Specialty Drinks icon
    title: 'Specialty Drinks',
    description: 'From classic lattes to creative seasonal specials, our menu has something for every coffee lover.',
  },
];

export default features;